import { cva } from 'class-variance-authority';

export const inputVariants = cva(
  [
    'flex-1',
    'relative',
    'p-0',
    'min-w-0',
    // w-full collapses the input's ~180px intrinsic min-content so ancestor
    // flex/grid columns can shrink the field (ATLAS-3561).
    'w-full',
    'min-h-[16px]',
    'border-0',
    'outline-none',
    'bg-transparent',
    '[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
  ],
  {
    variants: {
      isDisabled: {
        true: [
          'cursor-not-allowed',
          'text-color-comp-text-field-on-container-disabled',
          'placeholder-color-comp-text-field-on-container-disabled',
        ],
        false: [
          'cursor-text',
          'text-color-comp-text-field-on-container-selected',
          'placeholder-color-comp-text-field-on-container-enabled',
        ],
      },
      inputSize: {
        small: ['leading-sys-line-height-16'],
        medium: ['leading-sys-line-height-24'],
      },
    },
    defaultVariants: {
      isDisabled: false,
    },
  },
);

export const inputLTElementsVariants = cva(
  [
    '[&_>svg]:w-sizing-sys-size-24',
    '[&_>svg]:h-sizing-sys-size-24',
    '[&>svg]:fill-current',
    '[&>svg]:text-current',
    'flex-none',
    'items-center',
  ],
  {
    variants: {
      isString: {
        true: [
          'px-spacing-comp-text-field-medium-text-area-vertical',
          'h-auto',
        ],
        false: [],
      },
      isDisabled: {
        true: [
          'text-color-comp-button-strong-plain-on-container-disabled',
          'cursor-not-allowed',
        ],
        false: ['text-color-comp-action-strong-plain-on-container-enabled'],
      },
    },
    defaultVariants: {
      isString: false,
      isDisabled: false,
    },
  },
);
